import { render, staticRenderFns } from "./scPrayers.vue?vue&type=template&id=d75505b0&scoped=true&"
import script from "./scPrayers.vue?vue&type=script&lang=js&"
export * from "./scPrayers.vue?vue&type=script&lang=js&"
import style0 from "./scPrayers.vue?vue&type=style&index=0&id=d75505b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d75505b0",
  null
  
)

export default component.exports